var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6419",
    "data-name": "Path 6419",
    d: "M12,22A10,10,0,1,1,20,6H17.29a8,8,0,1,0,0,12H20A9.985,9.985,0,0,1,12,22Zm7-6V13H11V11h8V8l5,4Z",
    transform: "translate(-2 -2)",
    fill: "#6d6e6f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.834697b929783e8b9f8b494d997b3d5a.svg";
export { ForwardRef as ReactComponent };